// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobile-back-button_wrapper__xwMnq","mobileBackButton":"mobile-back-button_mobileBackButton__6lWvK"};